import React, { useEffect, useRef, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { iChevronUp, iChevronDown } from '@hover/icons';
import { Box, Container, Heading, Icon } from '@hover/blueprint';
import styled from '@emotion/styled';
import { INSURANCE_BETTER_WAY_TO_BUILD_CAROUSEL_DATA } from '../../../constants';
import { useInterval } from '../../../hooks';

const setting = {
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: true,
};

const StyledContainer = styled(Slider)`
  .slick-dots {
    display: flex !important;
    flex-direction: column;
    list-style: none;
    text-align: center;
    top: 40%;
    transform: translateY(-30%);
    right: -99%;
  }

  .slick-dots li {
    height: 30px;
  }

  .slick-dots li button:before {
    color: #d5d5d5 !important;
    font-size: 10px;
    opacity: 1;
  }

  .slick-dots li.slick-active button:before {
    color: #2277d1 !important;
  }
`;

const InvitedByInsuranceBetterWayDesktop: React.FC = () => {
  const sliderRef = useRef<Slider>(null);
  const [windowHeight, setWindowHeight] = useState<number>(
    typeof window !== 'undefined' ? window.innerHeight : 0,
  );
  const [isPlaying, setPlaying] = useState<boolean>(false);

  useInterval(
    () => {
      const activeItem =
        Number(
          document
            .getElementsByClassName('slick-active')[0]
            .getAttribute('data-index'),
        ) + 1;
      const scrollContainer: HTMLElement | null =
        document.getElementById('build-container');
      if (
        activeItem < 2 &&
        sliderRef?.current &&
        scrollContainer &&
        scrollContainer.clientHeight > 0
      ) {
        window?.scrollTo({ top: windowHeight * (activeItem + 2) });
        sliderRef.current.slickGoTo(activeItem);
      }
    },
    isPlaying ? 5000 : null,
  );

  useEffect(() => {
    setWindowHeight(window.innerHeight);
    const scrollContainer: HTMLElement | null =
      document.getElementById('build-container');
    const onScroll = () => {
      if (sliderRef?.current && scrollContainer) {
        const containerBounding = scrollContainer.getBoundingClientRect();
        const containerHeight = -containerBounding.y;

        if (containerHeight < 0) {
          sliderRef.current.slickGoTo(0);
          return setPlaying(false);
        }
        setPlaying(true);
        if (containerHeight >= 0 && containerHeight <= windowHeight) {
          return sliderRef.current.slickGoTo(0);
        }
        if (
          containerHeight >= windowHeight &&
          containerHeight <= windowHeight * 2
        ) {
          return sliderRef.current.slickGoTo(1);
        }
        if (containerHeight > windowHeight * 2) {
          sliderRef.current.slickGoTo(1);
          return setPlaying(false);
        }
      }
      return null;
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const sliderSetting = {
    ...setting,
    appendDots: (dots: JSX.Element[]) => {
      let newDots = [...dots];
      if (sliderRef.current) {
        newDots = [
          <Icon
            cursor="pointer"
            color="primary.300"
            ml="7px"
            mb={700}
            icon={iChevronUp}
            onClick={() => {
              const activeItem =
                Number(
                  document
                    .getElementsByClassName('slick-active')[0]
                    .getAttribute('data-index'),
                ) + 1;
              if (activeItem > 1 && sliderRef?.current) {
                window?.scrollTo({ top: windowHeight * activeItem });
                sliderRef.current?.slickPrev();
              }
            }}
          />,
          ...dots,
          <Icon
            color="primary.300"
            cursor="pointer"
            ml="7px"
            mt={600}
            icon={iChevronDown}
            onClick={() => {
              const activeItem =
                Number(
                  document
                    .getElementsByClassName('slick-active')[0]
                    .getAttribute('data-index'),
                ) + 1;
              if (activeItem < 2 && sliderRef?.current) {
                window?.scrollTo({ top: windowHeight * (activeItem + 2) });
                sliderRef.current?.slickNext();
              }
            }}
          />,
        ];
      }
      return <ul> {newDots} </ul>;
    },
  };

  return (
    <Container
      maxW="5xl"
      overflow="hidden"
      d={{ base: 'none', desktop: 'block' }}
      id="scroll-element"
    >
      <StyledContainer ref={sliderRef} {...sliderSetting}>
        {INSURANCE_BETTER_WAY_TO_BUILD_CAROUSEL_DATA.map(carouselItem => (
          <Box
            key={carouselItem.index}
            d="flex !important"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box maxW="170px">{carouselItem.img}</Box>
            <Box ml={1000} flex={1} alignItems="flex-start">
              <Box
                bg="green.500"
                alignItems="center"
                justifyContent="center"
                w="56px"
                h="56px"
                borderRadius="50%"
                mr={800}
              >
                <Icon icon={carouselItem.icon} size="large" color="neutral.0" />
              </Box>
              <Heading maxW={700} size={500} isLight>
                {carouselItem.body}
              </Heading>
            </Box>
          </Box>
        ))}
      </StyledContainer>
    </Container>
  );
};

export default InvitedByInsuranceBetterWayDesktop;
